import
{
	FormEvent,
	useEffect,
	useRef,
	useReducer,
	useState,
}
	from "react"
import {FontAwesomeIcon}
	from "@fortawesome/react-fontawesome"
import {solid}
	from "@fortawesome/fontawesome-svg-core/import.macro"
import {useDispatch, useSelector}
	from "react-redux"
import _
	from "lodash"
import Multiselect
	from "multiselect-react-dropdown"

import
{
	RootState,

	enableIdleLockSwitch,
	disableIdleLockSwitch,

	displayNotice,
	dismissNotice
}
	from "./../../globals"
import
{
	UIState,
	isEmpty,
	validateField,
	getAccessPermissions,
	getErrorMessage
}
	from "./../../common"
import Constants, {tunning}
	from "./../../constants"
import UnderlineHeading
	from "./../../components/underlineHeading"
import ListaTarjetas
	from "./../../components/listaTarjetas/listaTarjetas"
import {useEsTelefono}
	from "./../../utils/esTelefono"
import CustomIcon
	from "./../../components/customIcon"
import SectionContainer, {DataDisplayModal}
	from "./../../components/sectionContainer"
import RecipientAccountsService
	from "./../../services/recipientAccounts.service"
import CatalogService
	from "./../../services/catalog.service"

import "./../../components/dropdown/style.css"

type State = {isButtonDisabled : boolean}

const initialState : State = {isButtonDisabled : true}

type Action=
{
	type    : "setIsButtonDisabled",
	payload : boolean
}
const reducer = (state : State, action : Action) : State=>
{
	switch(action.type)
	{
		case "setIsButtonDisabled": 
			return{...state, isButtonDisabled : action.payload}
		break;
	}
}

const RecipientAccounts = ()=>
{
	const periods     : any[] = []
	const [state, trigger]                                        = useReducer(reducer, initialState)
	const dispatch                                                = useDispatch()
	const records      : any[]                                    = periods.map((record : any, index : number) => {return {selected : false, data : record}})
	const [totalRecords, setTotalRecords]                         = useState<number>(records.length)
	const [data, setData]                                         = useState<any[]>(records)
	const idleLocked   : boolean                                  = useSelector((state : RootState) => state.idleLockSwitch.value)
	const sessionToken : string | null                            = useSelector((state : RootState) => state.sessionToken.value)
	const themeToggle  : boolean                                  = useSelector((state : RootState) => state.themeToggle.value)
	const basicInfo    : any                                      = useSelector((state : RootState) => state.basicInfo.value)
	const currentUserCampus : any                                 = useSelector((state : RootState) => state.currentUserCampus.value)
	const campusRef         : any                                 = useSelector((state : RootState) => state.campusRef.value)
	const currentUser       : any                                 = useSelector((state : RootState) => state.userProfile.value)
	const [wrongValueDetail, setWrongValueDetail]                 = useState<string | null>(null)
	const [wrongValueOnFields, setWrongValueOnFields]             = useState<boolean>(false)
	const [unchangedRecord, setUnchangedRecord]                   = useState<boolean>(false)
	const [unfilledFields, setUnfilledFields]                     = useState<boolean>(false)
	const [sectionLoaded, setSectionLoaded]                       = useState<boolean>(false)
	const [userCampus, setUserCampus]                             = useState<number>(currentUserCampus)
	const [clearSearchRequested, setClearSearchRequested]         = useState<boolean>(false)
	const [UIStatus, setUIStatus]                                 = useState<number>(UIState.NORMAL)
	const [selectedRecords, setSelectedRecords]                   = useState<number>(0)
	const [defaultSearch, setDefaultSearch]                       = useState<any>({q : ""})
	const [customSearch, setCustomSearch]                         = useState<any>(defaultSearch)
	const [newRecipientAccount, setNewRecipientAccount]           = useState<any>(null)
	const [selectedRecipientAccount, setSelectedRecipientAccount] = useState<any>(null)
	const [editableRecipientAccount, setEditableRecipientAccount] = useState<any>(null)
	const [saveSuccess, setSaveSuccess]                           = useState<boolean>(false)
	const [saveError, setSaveError]                               = useState<any>(null)
	const [recordsSelection, setRecordsSelection]                 = useState<any>([])
	const [countries, setCountries]                                 = useState<any[]>()
	const count        : number[]                                 = [-1, 1]
	const esTelefono   : boolean                          = useEsTelefono(1024)
	const allowed      : any                                      = getAccessPermissions(currentUser)
	let   recordFormRef                                                 = useRef<HTMLFormElement >(null)
	let   descriptionRef                                          = useRef<HTMLTextAreaElement>(null)

	const searchCampuses = async (page? : number)=>
	{
		try
		{
			var expand : string | null = "base"

			dispatch(enableIdleLockSwitch())

			const result = await CatalogService.getCountries()

			if(result.status == 200 || result.status == 204)
			{
				setCountries(result.data)
				setSectionLoaded(true)
			}
		}
		catch(error)
		{
			console.log(error)
			searchError(getErrorMessage(error))
		}
		finally
		{
			dispatch(disableIdleLockSwitch())
			setClearSearchRequested(false)
		}
	}

	const searchError = (message: string)=>
	{
		dispatch
		(
			displayNotice
			({
				cornerClose : false,
				message     : `La búsqueda no pudo ser completada, ${message}` ,
				heading     : <h3 style={{color : "var(--wa-rojo-error)", display : "inline-block"}}>
					Error
				</h3>
			})
		)
	}

	const editRecipientAccount = ()=>
	{
		setEditableRecipientAccount
		({
			...selectedRecipientAccount, countryIds: selectedRecipientAccount.countries.map((country: any) => country.id).join(','),
			description: selectedRecipientAccount.description || ""
		})
	}

	const unedit = ()=>
	{
		if(editableRecipientAccount && editableRecipientAccount.id == null)
		{
			setSelectedRecipientAccount(null)
		}

		setEditableRecipientAccount(null)
	}

	const showPrompt = (recordData : any)=>
	{
		setUIStatus(UIState.NORMAL)

		if(recordData.id == null)
		{
			setEditableRecipientAccount(recordData)
		}

		setSelectedRecipientAccount(recordData)
	}

	const saveRecord = ()=>
	{
		if(recordFormRef && recordFormRef.current)
		{
			if(!recordFormRef.current.checkValidity())
			{
				if(!unfilledFields)
				{
					setUnfilledFields(true)
					recordFormRef.current.reportValidity()

					setTimeout
					(
						() => setUnfilledFields(false),
						3000
					)
				}
			}
			else
			{
				const dateDiff : number = (editableRecipientAccount.endValue - editableRecipientAccount.startValue) / 86400000

				if(editableRecipientAccount.startValue >= editableRecipientAccount.endValue || dateDiff < 6)
				{
					if(!wrongValueOnFields && wrongValueDetail == null)
					{
						setWrongValueOnFields(true)
						setWrongValueDetail
						(
							dateDiff < 6
									?
								"Un periodo válido debe contener al menos 6 días de diferencia entre inicio y fin"
									: "La fecha de Inicio no puede ser mayor a la fecha final"
						)

						setTimeout
						(
							()=>
							{
								setWrongValueOnFields(false)
								setWrongValueDetail(null)
							},
							3000
						)
					}
				}
				else
				{
					if(saveError)
					{
						setSaveError(null)
					}

					setUIStatus(UIState.LOCKED)
					dispatch(enableIdleLockSwitch());

					RecipientAccountsService.saveRecipientAccount(editableRecipientAccount).then
					(
						()=>
						{
							setSaveSuccess(true)
							setUIStatus(UIState.SUCCESS)

							setTimeout
							(
								()=>
								{
									setCustomSearch(defaultSearch)
									setSelectedRecipientAccount(null)
									setEditableRecipientAccount(null)
									setSaveSuccess(false)
									setUIStatus(UIState.NORMAL)
									search()
								},
								tunning.MODAL_DISMISS_DELAY
							)
						},
						(error : any)=>
						{
							console.log(error)
							setUIStatus(UIState.ERROR)
							dispatch(disableIdleLockSwitch())
							setSaveError(getErrorMessage(error))
						},
					)
				}
			}
		}
	}

	const handleSearchChange = (e : any)=>
	{
		if(e && e.target)
		{
			setCustomSearch
			({
				...customSearch,
				[e.target.name] : e.target.value
			})
		}
	}

	const handleRegistryChange = (e : any)=>
	{
		if(e && e.target)
		{
			setEditableRecipientAccount({...editableRecipientAccount, [e.target.name] : e.target.value})
		}
	}

	const procedureComplaint = (message : string)=>
	{
		dispatch
		(
			displayNotice
			({
				cornerClose : false,
				message     : message,
				heading     : <h3 style={{color : "var(--wa-rojo-error)", display : "inline-block"}}>
					Error
				</h3>
			})
		)
	}
	//FX---------------------------------------------------------------------------------------------------------------------
	useEffect
	(
		()=>
		{
			trigger
			({
				type    : "setIsButtonDisabled",
				payload : (idleLocked || UIStatus == UIState.SUCCESS)
			})
		},
		[UIStatus, idleLocked]
	)

	useEffect
	(
		()=>
		{
			if(sessionToken)
			{
				setNewRecipientAccount
				({
					name           : "",
					account_number : "",
					description    : ""
				})

				localStorage.setItem("currentCampus", currentUserCampus)
				setUserCampus(currentUserCampus)
				search()
				searchCampuses()
			}
		},
		[currentUserCampus, sectionLoaded]
	)

	useEffect(()=>{setTotalRecords(data.length)}, [data])

	useEffect
	(
		()=>
		{
			if (clearSearchRequested && _.isEqual(defaultSearch, customSearch))
			{
				search()
			}
		},
		[customSearch, clearSearchRequested]
	)
	//-----------------------------------------------------------------------------------------------------------------------
	const clearSearch = ()=>
	{
		setCustomSearch(defaultSearch)
		setClearSearchRequested(true)
	}

	const search = async(page? : any)=>
	{
		const searchError : string = "La búsqueda no pudo completarse"

		try
		{
			dispatch(enableIdleLockSwitch())

			const result = await RecipientAccountsService.getRecipientAccounts(campusRef[currentUserCampus].company.country_id)

			if(result.status == 200 || result.status == 204)
			{
				setData
				(
					result.data.map
					(
						(record : any, index : number)=>
						({
							selected : false,
							data     : record
						})
					)
				)

				setSelectedRecords(0)
				setSectionLoaded(true)
			}
		}
		catch(error)
		{
			console.log(error)
			procedureComplaint(`${searchError}, ${getErrorMessage(error)}`)
		}
		finally
		{
			dispatch(disableIdleLockSwitch())
			setClearSearchRequested(false)
		}
	}

	const toggleRecordSelection = (position : number)=>
	{
		setData
		(
			(current : any) => current.map
			(
				(record : any, index : number)=>
				{
					if(index == position)
					{
						setSelectedRecords(selectedRecords + count[ +!record.selected ])

						return {...record, selected : !record.selected};
					}

					return record;
				}
			)
		);
	};

	const toggleSelectAll = ()=>
	{
		const selected = selectedRecords < totalRecords

		setData
		(
			(current : any) => current.map
			(
				(record : any, index : number)=>
				{
					return {...record, selected : selected};
				}
			)
		);

		setSelectedRecords(totalRecords * (+selected))
	};

	const closePrompt = ()=>
	{
		setSelectedRecipientAccount(null)
		setEditableRecipientAccount(null)
	}

	const confirmRemoval = (recordId? : any)=>
	{
		dispatch
		(
			displayNotice
			({
				cornerClose : true,
				message     : "¿Eliminar registro" + (!isNaN(recordId) || recordsSelection.length < 2 ? "" : "s") + "?",
				heading     : <h3 style={{color : "var(--wa-tinta)", display : "inline-block"}}>
					Confirme
				</h3>,
				procedure   : async ()=>
				{
					const removalError : string   = "No se pudieron eliminar algunos registros. " +
						"Puede que la información en otra sección dependa de estos datos, " +
							"por lo que no será posible realizar por completo la operación"
					const recordIds    : number[] = !isNaN(recordId)
						? [recordId]
							: data.filter((item : any, index : number) => item.selected).map((item : any, index : number) => item.data.id)

					dispatch(enableIdleLockSwitch())
					dispatch(dismissNotice())

					try
					{
						const result = await RecipientAccountsService.removeRecipientAccounts(recordIds)

						if(result.status == 200 || result.status == 204)
						{
							setCustomSearch(defaultSearch)
							setData(data.map((record : any) => {return {selected : false, data : record.data}}))
							setSelectedRecords(0)
							search()
						}
					}
					catch(error: any)
					{
						console.log(error)
						procedureComplaint(getErrorMessage(error))
					}
					finally
					{
						dispatch(disableIdleLockSwitch())
					}
				}
			})
		)
	}

	return !sectionLoaded ? "" : <>
		<SectionContainer
		  searchFn={search}
		  allowed={allowed}
		  removalFn={confirmRemoval}
		  customSearch={customSearch}
		  clearSearchFn={clearSearch}
		  defaultSearch={defaultSearch}
		  selectedRecords={selectedRecords}
		  searchChangeFn={handleSearchChange}
		  clearSearchRequested={clearSearchRequested}
		  addingPromptFn={() => showPrompt(newRecipientAccount)}
		>{
			(data.length < 1)
				?
			<>
				<hr />
				<div style={{padding : "25px"}}>
					{Constants.noSearchResults}
				</div>
				<hr />
			</>
				:
			/* En telefono cada cuenta es una tarjeta. (Esteban, 2026-09-20) */
			esTelefono
					?
			<ListaTarjetas
				vacio="No hay cuentas que coincidan."
				tarjetas={data.map((record : any) =>
				({
					clave    : record.data.id,
					titulo   : record.data.name,
					subtitulo: record.data.account_number,
					campos   : [{etiqueta : "Descripción", valor : record.data.description, ancho : true}],
					acciones : [{texto : "Ver", principal : true, disabled : idleLocked, onClick : () => showPrompt(record.data)}],
					menu     : !allowed.delete ? [] : [{texto : "Borrar", onClick : () => confirmRemoval(record.data.id)}]
				}))}
			/>
					:
			<table className="commonTable">
				<thead><tr key="periodsHeader">
					{
						!allowed.delete ? "" : <th><button className="btn btn-default" onClick={toggleSelectAll}
						  disabled={idleLocked || saveSuccess} type="button"
						>
							{<CustomIcon name={selectedRecords == totalRecords ? "bCheck" : "bUncheck"} />}
						</button></th>
					}
					<th>
						id
					</th>
					<th>
						Nombre
					</th>
					<th>
						Número
					</th>
					<th>
						Descripción
					</th>
					<th>
					</th>
				</tr></thead>
				<tbody>{
					data.filter
					(
						(record : any) => (record && isEmpty(customSearch.q)) ||
						(
							record.data.name.indexOf(customSearch.q) >= 0 ||
							(
								record.data.account_number.indexOf(customSearch.q) >= 0 ||
								(record.data.description && record.data.description.indexOf(customSearch.q) >= 0)
							)
						)
					).map
					(
						(record : any, index : number) => <tr key={"period" + index}>
							{
								/* Misma regla que el encabezado: sin permiso de borrar no hay columna de casilla (Esteban, 2026-10-22). */
								!allowed.delete ? "" : <td>
									<button disabled={idleLocked} className="btn btn-default" type="button"
									  onClick={() => toggleRecordSelection(index)}
									>
										{<CustomIcon name={record.selected ? "bCheck" : "bUncheck"} />}
									</button>
								</td>
							}
							<td>
								{record.data.id}
							</td>
							<td>
								{record.data.name}
							</td>
							<td>
								{record.data.account_number}
							</td>
							<td>
								{record.data.description || "-"}
							</td>
							<td><div style={{display : "flex"}}>
								<button disabled={idleLocked} className="button btn btn-default"
								  style={{display : "table-column", color : "var(--txt-color)", paddingTop : "10px"}}
								  type="button" onClick={() => showPrompt(record.data)}
								>
									<span className="waVer">Ver</span>
								</button>
								{
									!allowed.delete ? "" : <button onClick={() => confirmRemoval(record.data.id)} type="button"
									  className="button btn btn-default" style={{display : "table-column"}}
									  disabled={idleLocked}
									>
										<CustomIcon name="bTrash" />
									</button>
								}
							</div></td>
						</tr>
					)
				}</tbody>
			</table>
		}</SectionContainer>
		{
			selectedRecipientAccount == null ? "" : <DataDisplayModal saveSuccess={saveSuccess} allowedUpdate={allowed.update}
			  unchangedRecord={unchangedRecord} saveLock={state.isButtonDisabled} promptCloseFn={closePrompt} saveDataFn={saveRecord}
			  UIStatus={UIStatus} dataEditInit={editRecipientAccount} processingError={saveError} entityName="Cuenta receptora"
			  unfilledFields={unfilledFields} wrongValueOnFields={wrongValueOnFields} uneditFn={unedit} form={recordFormRef}
			  headIcon={<FontAwesomeIcon icon={solid("money-check-dollar")} />} editableRecord={editableRecipientAccount}
			><form ref={recordFormRef} className="form" onSubmit=
			  {
				(event : FormEvent)=>
				{
					event.preventDefault()
					saveRecord()
				}
			  }
			>
				<div className="container"><div className="row">
					<div className="col-md-6"><div className="inputContainer">
						<label htmlFor="name">
							Nombre
						</label>
						{
							editableRecipientAccount == null
								?
							<div className="roView">
								<br />
								{selectedRecipientAccount.name}
							</div>
								:
							<input onBlur={validateField} placeholder="Nombre" type="text"
							  value={editableRecipientAccount.name} style={{width : "100%"}} disabled={idleLocked} id="name"
							  onChange={handleRegistryChange} maxLength={50} name="name"
							  onFocus={validateField} required
							/>
						}
					</div></div>
					<div className="col-md-6"><div className="inputContainer">
						<label htmlFor="name">
							Número
						</label>
						{
							editableRecipientAccount == null
								?
							<div className="roView">
								<br />
								{selectedRecipientAccount.account_number}
							</div>
								:
							<input value={editableRecipientAccount.account_number} placeholder="Número" id="account_number"
							  onBlur={validateField} name="account_number" type="text"
							  onFocus={validateField} style={{width : "100%"}} onChange=
							  {
								(event : any) => setEditableRecipientAccount
									({...editableRecipientAccount, account_number : event.target.value.replace(/\D/g, "")})
							  } disabled={idleLocked} min={0} required
							/>
						}
					</div></div>
					<div className="col-md-6"><div>
						<label htmlFor="tags" style={{position : "unset"}}>
							País
						</label>
						{
							editableRecipientAccount == null
									?
								<div>{
									selectedRecipientAccount.countries.length < 1 ? "-" : selectedRecipientAccount.countries.map
									(
										(country : any, index: number) => <div className="badge badge-pill bg-primary"
										  key={"co_" + country.id}
										>
											{country.name}
										</div>
									)
								}</div>
									:
								<Multiselect options={countries} displayValue="name" emptyRecordMsg="No hay más opciones"
								  onSelect={(countries) => setEditableRecipientAccount({...editableRecipientAccount, countryIds : countries.map((country: any) => country.id).join(',')})}
								  onRemove={(countries) => setEditableRecipientAccount({...editableRecipientAccount, countryIds : countries.map((country: any) => country.id).join(',')})}
								  selectedValues={editableRecipientAccount.countries}
								/>
						}
					</div></div>

				</div></div>
				<div style={{paddingTop : "25px"}}>
					<UnderlineHeading name={"Descripción"} />
					<div style={{paddingTop : "3px"}}>{
						editableRecipientAccount == null
								?
							(selectedRecipientAccount.description || "-")
								:
							<textarea onChange={handleRegistryChange} name="description"
							  value={editableRecipientAccount.description} ref={descriptionRef} disabled={idleLocked}
							  id="description" className="notesField form-control" maxLength={255}
							/>
					}</div>
				</div>
				<br />
				<br />
				<br />
				<br />
				<br />
			</form></DataDisplayModal>
		}
	</>
}

export default RecipientAccounts
